export const disallowedEmailDomains = [
  'vusra',
  'zohomail',
  'wetra.life',
  'orange',
  'pussport',
  'o2',
  'herrain',
  'betaalverzoek.cyou',
  'grabmail',
  'afcamail',
  'advew',
  'uniromax',
  'kibwot',
  'ymail',
  'vip.qq',
  'wetra.life',
  'workingtall',
  'riseup',
  '5sword',
  'zooape',
  'seek4wap',
  'inbox',
  'tuta',
  'macauvpn',
  'pm.me',
  'school',
  'tutanota',
  'go',
  '0range',
  'students',
  'activesniper',
  'nhmty',
  'naver',
  'email',
  'me',
  'qq',
  '100xbit',
  'dedatre',
  'alumno',
  'hitmail',
  'pigicorn',
  'ptd',
  'list',
  'yandex',
  'paseacuba',
  'solarunited',
  'msn',
  'live',
  'ya',
  'bk',
  'w3boats',
  'pasecuba',
  'my',
  'hotmail',
  'seatto',
  'jq600',
  'aol',
  'edu',
  'outlook',
  'icloud',
  'yahoo',
  'mail',
  'web',
  'protonmail',
  'gmx',
] as const;
